// extracted by mini-css-extract-plugin
export default {"container":"aee57125","table":"e2a30064"};